import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import LayersButton, { Props } from '../_components/LayersButton';
import { OnLayerListVisibilityToggle } from '../../LayerList/_actions/LayerListActions';

const mapStateToProps = (store:Store, props:Props) => ({
	layerListOpened : store.getIn(['create', 'layerList', 'opened']),
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onClick: () => dispatch(OnLayerListVisibilityToggle()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LayersButton);